/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LoginRouteImport } from './routes/login'
import { Route as CrisisResourcesRouteImport } from './routes/crisis-resources'
import { Route as AuthedRouteImport } from './routes/_authed'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthedTodayRouteImport } from './routes/_authed.today'
import { Route as AuthedSettingsRouteImport } from './routes/_authed.settings'
import { Route as AuthedProfileRouteImport } from './routes/_authed.profile'
import { Route as AuthedOnboardingRouteImport } from './routes/_authed.onboarding'
import { Route as AuthedHistoryRouteImport } from './routes/_authed.history'
import { Route as AuthedFounderRouteImport } from './routes/_authed.founder'
import { Route as AuthedCoachRouteImport } from './routes/_authed.coach'
import { Route as AuthedBillingRouteImport } from './routes/_authed.billing'
import { Route as AuthedAdminRouteImport } from './routes/_authed.admin'
import { Route as AuthedPracticesIndexRouteImport } from './routes/_authed.practices.index'
import { Route as AuthedFounderIndexRouteImport } from './routes/_authed.founder.index'
import { Route as AuthedCommunityIndexRouteImport } from './routes/_authed.community.index'
import { Route as AuthedBiometricsIndexRouteImport } from './routes/_authed.biometrics.index'
import { Route as AuthedPracticesIdRouteImport } from './routes/_authed.practices.$id'
import { Route as AuthedFounderTimeAuditRouteImport } from './routes/_authed.founder.time-audit'
import { Route as AuthedFounderProofRouteImport } from './routes/_authed.founder.proof'
import { Route as AuthedFounderIdentityOutputRouteImport } from './routes/_authed.founder.identity-output'
import { Route as AuthedFounderDecisionsRouteImport } from './routes/_authed.founder.decisions'
import { Route as AuthedFounderCheckinRouteImport } from './routes/_authed.founder.checkin'
import { Route as AuthedFounderCalendarRouteImport } from './routes/_authed.founder.calendar'
import { Route as AuthedCommunityRoomsRouteImport } from './routes/_authed.community.rooms'
import { Route as AuthedCommunityMatchesRouteImport } from './routes/_authed.community.matches'
import { Route as AuthedBiometricsBreathingRouteImport } from './routes/_authed.biometrics.breathing'
import { Route as AuthedCommunityRoomsIdRouteImport } from './routes/_authed.community.rooms.$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const CrisisResourcesRoute = CrisisResourcesRouteImport.update({
  id: '/crisis-resources',
  path: '/crisis-resources',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedRoute = AuthedRouteImport.update({
  id: '/_authed',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthedTodayRoute = AuthedTodayRouteImport.update({
  id: '/today',
  path: '/today',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedSettingsRoute = AuthedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedProfileRoute = AuthedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedOnboardingRoute = AuthedOnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedHistoryRoute = AuthedHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedFounderRoute = AuthedFounderRouteImport.update({
  id: '/founder',
  path: '/founder',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCoachRoute = AuthedCoachRouteImport.update({
  id: '/coach',
  path: '/coach',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedBillingRoute = AuthedBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedAdminRoute = AuthedAdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPracticesIndexRoute = AuthedPracticesIndexRouteImport.update({
  id: '/practices/',
  path: '/practices/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedFounderIndexRoute = AuthedFounderIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthedFounderRoute,
} as any)
const AuthedCommunityIndexRoute = AuthedCommunityIndexRouteImport.update({
  id: '/community/',
  path: '/community/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedBiometricsIndexRoute = AuthedBiometricsIndexRouteImport.update({
  id: '/biometrics/',
  path: '/biometrics/',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedPracticesIdRoute = AuthedPracticesIdRouteImport.update({
  id: '/practices/$id',
  path: '/practices/$id',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedFounderTimeAuditRoute = AuthedFounderTimeAuditRouteImport.update({
  id: '/time-audit',
  path: '/time-audit',
  getParentRoute: () => AuthedFounderRoute,
} as any)
const AuthedFounderProofRoute = AuthedFounderProofRouteImport.update({
  id: '/proof',
  path: '/proof',
  getParentRoute: () => AuthedFounderRoute,
} as any)
const AuthedFounderIdentityOutputRoute =
  AuthedFounderIdentityOutputRouteImport.update({
    id: '/identity-output',
    path: '/identity-output',
    getParentRoute: () => AuthedFounderRoute,
  } as any)
const AuthedFounderDecisionsRoute = AuthedFounderDecisionsRouteImport.update({
  id: '/decisions',
  path: '/decisions',
  getParentRoute: () => AuthedFounderRoute,
} as any)
const AuthedFounderCheckinRoute = AuthedFounderCheckinRouteImport.update({
  id: '/checkin',
  path: '/checkin',
  getParentRoute: () => AuthedFounderRoute,
} as any)
const AuthedFounderCalendarRoute = AuthedFounderCalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AuthedFounderRoute,
} as any)
const AuthedCommunityRoomsRoute = AuthedCommunityRoomsRouteImport.update({
  id: '/community/rooms',
  path: '/community/rooms',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedCommunityMatchesRoute = AuthedCommunityMatchesRouteImport.update({
  id: '/community/matches',
  path: '/community/matches',
  getParentRoute: () => AuthedRoute,
} as any)
const AuthedBiometricsBreathingRoute =
  AuthedBiometricsBreathingRouteImport.update({
    id: '/biometrics/breathing',
    path: '/biometrics/breathing',
    getParentRoute: () => AuthedRoute,
  } as any)
const AuthedCommunityRoomsIdRoute = AuthedCommunityRoomsIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => AuthedCommunityRoomsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/crisis-resources': typeof CrisisResourcesRoute
  '/login': typeof LoginRoute
  '/admin': typeof AuthedAdminRoute
  '/billing': typeof AuthedBillingRoute
  '/coach': typeof AuthedCoachRoute
  '/founder': typeof AuthedFounderRouteWithChildren
  '/history': typeof AuthedHistoryRoute
  '/onboarding': typeof AuthedOnboardingRoute
  '/profile': typeof AuthedProfileRoute
  '/settings': typeof AuthedSettingsRoute
  '/today': typeof AuthedTodayRoute
  '/biometrics/breathing': typeof AuthedBiometricsBreathingRoute
  '/community/matches': typeof AuthedCommunityMatchesRoute
  '/community/rooms': typeof AuthedCommunityRoomsRouteWithChildren
  '/founder/calendar': typeof AuthedFounderCalendarRoute
  '/founder/checkin': typeof AuthedFounderCheckinRoute
  '/founder/decisions': typeof AuthedFounderDecisionsRoute
  '/founder/identity-output': typeof AuthedFounderIdentityOutputRoute
  '/founder/proof': typeof AuthedFounderProofRoute
  '/founder/time-audit': typeof AuthedFounderTimeAuditRoute
  '/practices/$id': typeof AuthedPracticesIdRoute
  '/biometrics/': typeof AuthedBiometricsIndexRoute
  '/community/': typeof AuthedCommunityIndexRoute
  '/founder/': typeof AuthedFounderIndexRoute
  '/practices/': typeof AuthedPracticesIndexRoute
  '/community/rooms/$id': typeof AuthedCommunityRoomsIdRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/crisis-resources': typeof CrisisResourcesRoute
  '/login': typeof LoginRoute
  '/admin': typeof AuthedAdminRoute
  '/billing': typeof AuthedBillingRoute
  '/coach': typeof AuthedCoachRoute
  '/history': typeof AuthedHistoryRoute
  '/onboarding': typeof AuthedOnboardingRoute
  '/profile': typeof AuthedProfileRoute
  '/settings': typeof AuthedSettingsRoute
  '/today': typeof AuthedTodayRoute
  '/biometrics/breathing': typeof AuthedBiometricsBreathingRoute
  '/community/matches': typeof AuthedCommunityMatchesRoute
  '/community/rooms': typeof AuthedCommunityRoomsRouteWithChildren
  '/founder/calendar': typeof AuthedFounderCalendarRoute
  '/founder/checkin': typeof AuthedFounderCheckinRoute
  '/founder/decisions': typeof AuthedFounderDecisionsRoute
  '/founder/identity-output': typeof AuthedFounderIdentityOutputRoute
  '/founder/proof': typeof AuthedFounderProofRoute
  '/founder/time-audit': typeof AuthedFounderTimeAuditRoute
  '/practices/$id': typeof AuthedPracticesIdRoute
  '/biometrics': typeof AuthedBiometricsIndexRoute
  '/community': typeof AuthedCommunityIndexRoute
  '/founder': typeof AuthedFounderIndexRoute
  '/practices': typeof AuthedPracticesIndexRoute
  '/community/rooms/$id': typeof AuthedCommunityRoomsIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authed': typeof AuthedRouteWithChildren
  '/crisis-resources': typeof CrisisResourcesRoute
  '/login': typeof LoginRoute
  '/_authed/admin': typeof AuthedAdminRoute
  '/_authed/billing': typeof AuthedBillingRoute
  '/_authed/coach': typeof AuthedCoachRoute
  '/_authed/founder': typeof AuthedFounderRouteWithChildren
  '/_authed/history': typeof AuthedHistoryRoute
  '/_authed/onboarding': typeof AuthedOnboardingRoute
  '/_authed/profile': typeof AuthedProfileRoute
  '/_authed/settings': typeof AuthedSettingsRoute
  '/_authed/today': typeof AuthedTodayRoute
  '/_authed/biometrics/breathing': typeof AuthedBiometricsBreathingRoute
  '/_authed/community/matches': typeof AuthedCommunityMatchesRoute
  '/_authed/community/rooms': typeof AuthedCommunityRoomsRouteWithChildren
  '/_authed/founder/calendar': typeof AuthedFounderCalendarRoute
  '/_authed/founder/checkin': typeof AuthedFounderCheckinRoute
  '/_authed/founder/decisions': typeof AuthedFounderDecisionsRoute
  '/_authed/founder/identity-output': typeof AuthedFounderIdentityOutputRoute
  '/_authed/founder/proof': typeof AuthedFounderProofRoute
  '/_authed/founder/time-audit': typeof AuthedFounderTimeAuditRoute
  '/_authed/practices/$id': typeof AuthedPracticesIdRoute
  '/_authed/biometrics/': typeof AuthedBiometricsIndexRoute
  '/_authed/community/': typeof AuthedCommunityIndexRoute
  '/_authed/founder/': typeof AuthedFounderIndexRoute
  '/_authed/practices/': typeof AuthedPracticesIndexRoute
  '/_authed/community/rooms/$id': typeof AuthedCommunityRoomsIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/crisis-resources'
    | '/login'
    | '/admin'
    | '/billing'
    | '/coach'
    | '/founder'
    | '/history'
    | '/onboarding'
    | '/profile'
    | '/settings'
    | '/today'
    | '/biometrics/breathing'
    | '/community/matches'
    | '/community/rooms'
    | '/founder/calendar'
    | '/founder/checkin'
    | '/founder/decisions'
    | '/founder/identity-output'
    | '/founder/proof'
    | '/founder/time-audit'
    | '/practices/$id'
    | '/biometrics/'
    | '/community/'
    | '/founder/'
    | '/practices/'
    | '/community/rooms/$id'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/crisis-resources'
    | '/login'
    | '/admin'
    | '/billing'
    | '/coach'
    | '/history'
    | '/onboarding'
    | '/profile'
    | '/settings'
    | '/today'
    | '/biometrics/breathing'
    | '/community/matches'
    | '/community/rooms'
    | '/founder/calendar'
    | '/founder/checkin'
    | '/founder/decisions'
    | '/founder/identity-output'
    | '/founder/proof'
    | '/founder/time-audit'
    | '/practices/$id'
    | '/biometrics'
    | '/community'
    | '/founder'
    | '/practices'
    | '/community/rooms/$id'
  id:
    | '__root__'
    | '/'
    | '/_authed'
    | '/crisis-resources'
    | '/login'
    | '/_authed/admin'
    | '/_authed/billing'
    | '/_authed/coach'
    | '/_authed/founder'
    | '/_authed/history'
    | '/_authed/onboarding'
    | '/_authed/profile'
    | '/_authed/settings'
    | '/_authed/today'
    | '/_authed/biometrics/breathing'
    | '/_authed/community/matches'
    | '/_authed/community/rooms'
    | '/_authed/founder/calendar'
    | '/_authed/founder/checkin'
    | '/_authed/founder/decisions'
    | '/_authed/founder/identity-output'
    | '/_authed/founder/proof'
    | '/_authed/founder/time-audit'
    | '/_authed/practices/$id'
    | '/_authed/biometrics/'
    | '/_authed/community/'
    | '/_authed/founder/'
    | '/_authed/practices/'
    | '/_authed/community/rooms/$id'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthedRoute: typeof AuthedRouteWithChildren
  CrisisResourcesRoute: typeof CrisisResourcesRoute
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/crisis-resources': {
      id: '/crisis-resources'
      path: '/crisis-resources'
      fullPath: '/crisis-resources'
      preLoaderRoute: typeof CrisisResourcesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed': {
      id: '/_authed'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authed/today': {
      id: '/_authed/today'
      path: '/today'
      fullPath: '/today'
      preLoaderRoute: typeof AuthedTodayRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/settings': {
      id: '/_authed/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthedSettingsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/profile': {
      id: '/_authed/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthedProfileRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/onboarding': {
      id: '/_authed/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof AuthedOnboardingRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/history': {
      id: '/_authed/history'
      path: '/history'
      fullPath: '/history'
      preLoaderRoute: typeof AuthedHistoryRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/founder': {
      id: '/_authed/founder'
      path: '/founder'
      fullPath: '/founder'
      preLoaderRoute: typeof AuthedFounderRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/coach': {
      id: '/_authed/coach'
      path: '/coach'
      fullPath: '/coach'
      preLoaderRoute: typeof AuthedCoachRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/billing': {
      id: '/_authed/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AuthedBillingRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/admin': {
      id: '/_authed/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AuthedAdminRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/practices/': {
      id: '/_authed/practices/'
      path: '/practices'
      fullPath: '/practices/'
      preLoaderRoute: typeof AuthedPracticesIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/founder/': {
      id: '/_authed/founder/'
      path: '/'
      fullPath: '/founder/'
      preLoaderRoute: typeof AuthedFounderIndexRouteImport
      parentRoute: typeof AuthedFounderRoute
    }
    '/_authed/community/': {
      id: '/_authed/community/'
      path: '/community'
      fullPath: '/community/'
      preLoaderRoute: typeof AuthedCommunityIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/biometrics/': {
      id: '/_authed/biometrics/'
      path: '/biometrics'
      fullPath: '/biometrics/'
      preLoaderRoute: typeof AuthedBiometricsIndexRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/practices/$id': {
      id: '/_authed/practices/$id'
      path: '/practices/$id'
      fullPath: '/practices/$id'
      preLoaderRoute: typeof AuthedPracticesIdRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/founder/time-audit': {
      id: '/_authed/founder/time-audit'
      path: '/time-audit'
      fullPath: '/founder/time-audit'
      preLoaderRoute: typeof AuthedFounderTimeAuditRouteImport
      parentRoute: typeof AuthedFounderRoute
    }
    '/_authed/founder/proof': {
      id: '/_authed/founder/proof'
      path: '/proof'
      fullPath: '/founder/proof'
      preLoaderRoute: typeof AuthedFounderProofRouteImport
      parentRoute: typeof AuthedFounderRoute
    }
    '/_authed/founder/identity-output': {
      id: '/_authed/founder/identity-output'
      path: '/identity-output'
      fullPath: '/founder/identity-output'
      preLoaderRoute: typeof AuthedFounderIdentityOutputRouteImport
      parentRoute: typeof AuthedFounderRoute
    }
    '/_authed/founder/decisions': {
      id: '/_authed/founder/decisions'
      path: '/decisions'
      fullPath: '/founder/decisions'
      preLoaderRoute: typeof AuthedFounderDecisionsRouteImport
      parentRoute: typeof AuthedFounderRoute
    }
    '/_authed/founder/checkin': {
      id: '/_authed/founder/checkin'
      path: '/checkin'
      fullPath: '/founder/checkin'
      preLoaderRoute: typeof AuthedFounderCheckinRouteImport
      parentRoute: typeof AuthedFounderRoute
    }
    '/_authed/founder/calendar': {
      id: '/_authed/founder/calendar'
      path: '/calendar'
      fullPath: '/founder/calendar'
      preLoaderRoute: typeof AuthedFounderCalendarRouteImport
      parentRoute: typeof AuthedFounderRoute
    }
    '/_authed/community/rooms': {
      id: '/_authed/community/rooms'
      path: '/community/rooms'
      fullPath: '/community/rooms'
      preLoaderRoute: typeof AuthedCommunityRoomsRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/community/matches': {
      id: '/_authed/community/matches'
      path: '/community/matches'
      fullPath: '/community/matches'
      preLoaderRoute: typeof AuthedCommunityMatchesRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/biometrics/breathing': {
      id: '/_authed/biometrics/breathing'
      path: '/biometrics/breathing'
      fullPath: '/biometrics/breathing'
      preLoaderRoute: typeof AuthedBiometricsBreathingRouteImport
      parentRoute: typeof AuthedRoute
    }
    '/_authed/community/rooms/$id': {
      id: '/_authed/community/rooms/$id'
      path: '/$id'
      fullPath: '/community/rooms/$id'
      preLoaderRoute: typeof AuthedCommunityRoomsIdRouteImport
      parentRoute: typeof AuthedCommunityRoomsRoute
    }
  }
}

interface AuthedFounderRouteChildren {
  AuthedFounderCalendarRoute: typeof AuthedFounderCalendarRoute
  AuthedFounderCheckinRoute: typeof AuthedFounderCheckinRoute
  AuthedFounderDecisionsRoute: typeof AuthedFounderDecisionsRoute
  AuthedFounderIdentityOutputRoute: typeof AuthedFounderIdentityOutputRoute
  AuthedFounderProofRoute: typeof AuthedFounderProofRoute
  AuthedFounderTimeAuditRoute: typeof AuthedFounderTimeAuditRoute
  AuthedFounderIndexRoute: typeof AuthedFounderIndexRoute
}

const AuthedFounderRouteChildren: AuthedFounderRouteChildren = {
  AuthedFounderCalendarRoute: AuthedFounderCalendarRoute,
  AuthedFounderCheckinRoute: AuthedFounderCheckinRoute,
  AuthedFounderDecisionsRoute: AuthedFounderDecisionsRoute,
  AuthedFounderIdentityOutputRoute: AuthedFounderIdentityOutputRoute,
  AuthedFounderProofRoute: AuthedFounderProofRoute,
  AuthedFounderTimeAuditRoute: AuthedFounderTimeAuditRoute,
  AuthedFounderIndexRoute: AuthedFounderIndexRoute,
}

const AuthedFounderRouteWithChildren = AuthedFounderRoute._addFileChildren(
  AuthedFounderRouteChildren,
)

interface AuthedCommunityRoomsRouteChildren {
  AuthedCommunityRoomsIdRoute: typeof AuthedCommunityRoomsIdRoute
}

const AuthedCommunityRoomsRouteChildren: AuthedCommunityRoomsRouteChildren = {
  AuthedCommunityRoomsIdRoute: AuthedCommunityRoomsIdRoute,
}

const AuthedCommunityRoomsRouteWithChildren =
  AuthedCommunityRoomsRoute._addFileChildren(AuthedCommunityRoomsRouteChildren)

interface AuthedRouteChildren {
  AuthedAdminRoute: typeof AuthedAdminRoute
  AuthedBillingRoute: typeof AuthedBillingRoute
  AuthedCoachRoute: typeof AuthedCoachRoute
  AuthedFounderRoute: typeof AuthedFounderRouteWithChildren
  AuthedHistoryRoute: typeof AuthedHistoryRoute
  AuthedOnboardingRoute: typeof AuthedOnboardingRoute
  AuthedProfileRoute: typeof AuthedProfileRoute
  AuthedSettingsRoute: typeof AuthedSettingsRoute
  AuthedTodayRoute: typeof AuthedTodayRoute
  AuthedBiometricsBreathingRoute: typeof AuthedBiometricsBreathingRoute
  AuthedCommunityMatchesRoute: typeof AuthedCommunityMatchesRoute
  AuthedCommunityRoomsRoute: typeof AuthedCommunityRoomsRouteWithChildren
  AuthedPracticesIdRoute: typeof AuthedPracticesIdRoute
  AuthedBiometricsIndexRoute: typeof AuthedBiometricsIndexRoute
  AuthedCommunityIndexRoute: typeof AuthedCommunityIndexRoute
  AuthedPracticesIndexRoute: typeof AuthedPracticesIndexRoute
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedAdminRoute: AuthedAdminRoute,
  AuthedBillingRoute: AuthedBillingRoute,
  AuthedCoachRoute: AuthedCoachRoute,
  AuthedFounderRoute: AuthedFounderRouteWithChildren,
  AuthedHistoryRoute: AuthedHistoryRoute,
  AuthedOnboardingRoute: AuthedOnboardingRoute,
  AuthedProfileRoute: AuthedProfileRoute,
  AuthedSettingsRoute: AuthedSettingsRoute,
  AuthedTodayRoute: AuthedTodayRoute,
  AuthedBiometricsBreathingRoute: AuthedBiometricsBreathingRoute,
  AuthedCommunityMatchesRoute: AuthedCommunityMatchesRoute,
  AuthedCommunityRoomsRoute: AuthedCommunityRoomsRouteWithChildren,
  AuthedPracticesIdRoute: AuthedPracticesIdRoute,
  AuthedBiometricsIndexRoute: AuthedBiometricsIndexRoute,
  AuthedCommunityIndexRoute: AuthedCommunityIndexRoute,
  AuthedPracticesIndexRoute: AuthedPracticesIndexRoute,
}

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  CrisisResourcesRoute: CrisisResourcesRoute,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
